var ApplicationCreateService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { RouterParamsService } from "../../../shared/services/route-params.service";
import { ApiStepMetaConstants } from "../../../shared/constants/api-constants/api-step-meta.constants";
import { map, take, takeUntil } from "rxjs/operators";
import { ApiLookupConstants } from "../../../shared/constants/api-constants/api-lookup.constants";
import { TrueCentroidResultsModel } from "../../../shared/models/gpserver-truecentroid-model";
import { ApiPropertyValuationValuationRollConstants } from "../../../shared/constants/api-constants/api-property-valuation-valuation-roll.constants";
import { ApiModuleMapConstants } from "../../../shared/constants/api-constants/api-module-map.constants";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { AutoUnsub } from "../../../shared/decorators/autounsub.decorator";
import { ApiModuleConstants } from "../../../shared/constants/api-constants/api-module.constants";
let ApplicationCreateService = class ApplicationCreateService {
    static { ApplicationCreateService_1 = this; }
    http;
    authService;
    routeParamsService;
    _destroy$ = new Subject();
    moduleID;
    propertyData;
    applicationData;
    propertySubject = new BehaviorSubject(undefined);
    propertyObservable = this.propertySubject.asObservable();
    startMetadataSubject = new BehaviorSubject(null);
    $startMetadata = this.startMetadataSubject.asObservable();
    $clearApplicationVerificationSubject = new BehaviorSubject(false);
    $removeShowBaySubject = new BehaviorSubject(false);
    $removeTradersRecipientListButtonsSubject = new BehaviorSubject(false);
    routeParamsSubscription;
    constructor(http, authService, routeParamsService) {
        this.http = http;
        this.authService = authService;
        this.routeParamsService = routeParamsService;
    }
    static checkIfChanged(newValue, oldValue) {
        if (!newValue) {
            // throw new Error("Value must exist");
        }
        return newValue !== oldValue;
    }
    // TODO: Not in use? Can be removed?
    savePropertyData(property) {
        this.propertyData.data = property;
        this.propertySubject.next(this.propertyData.data);
    }
    start() {
        this.routeParamsSubscription = this.routeParamsService.params.subscribe(async (params) => {
            await this.handleRouteParamChange(params);
        });
    }
    async getStepMeta() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        await this.http.get(ApiStepMetaConstants.URL, { params }).pipe(takeUntil(this._destroy$), take(1)).subscribe((metadata) => {
            this.startMetadataSubject.next(JSON.parse(metadata.value[0].metadata));
        });
    }
    getLookupsObservable(params) {
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(map(lookups => {
            return lookups;
        }));
    }
    getTrueCentroid(url, params) {
        return this.http.post(url, params).pipe(map((response) => {
            return new TrueCentroidResultsModel().deserialize(response);
        }));
    }
    async handleRouteParamChange(params) {
        if (params && ApplicationCreateService_1.checkIfChanged(params.moduleid, this.moduleID)) {
            this.moduleID = params.moduleid;
            if (this.moduleID !== undefined && this.moduleID !== null) {
                await this.getStepMeta();
            }
        }
    }
    getValuationRolls(params) {
        return this.http.get(`${ApiPropertyValuationValuationRollConstants.URL}`, { params });
    }
    sendMissingLookupsEmail(params) {
        return this.http.post(`${ApiModuleConstants.URL}/${ApiModuleConstants.MISSING_LOOKUP_EMAIL_REQUEST_URL}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    getModuleMaps(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId}`,
            $orderby: "mapOrder desc"
        };
        return this.http.get(ApiModuleMapConstants.URL, { params });
    }
    queryMapViaProxy(url, moduleMapId) {
        const params = {
            MapServiceId: moduleMapId, Authorization: this.authService.getAuthToken()
        };
        // @ts-ignore
        return this.http.get(url, { headers: params });
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AuthService },
        { type: RouterParamsService }
    ];
};
ApplicationCreateService = ApplicationCreateService_1 = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], ApplicationCreateService);
export { ApplicationCreateService };
